import { normalize } from "normalizr";
import endpoints from "api/endpoints";
import Immutable from "immutable";
import { payment as paymentSchemas } from "schemas";

export default (
  { resultKey = "payment", paymentId } = { resultKey: "payment" }
) => ({
  url: endpoints.getChangeStatusPaymentUrl(paymentId),
  transform: (response) =>
    normalize(response.data, paymentSchemas.paymentSchema).entities,
  transformResult: (response) => ({
    [resultKey]: normalize(response.data, paymentSchemas.paymentSchema).result,
  }),
  queryKey: endpoints.getChangeStatusPaymentUrl(paymentId),
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: "application/json",
    },
    method: "PUT",
  },
  update: {
    payment: (prevPayment = Immutable.Map(), payment) =>
      prevPayment.mergeDeep(payment),
  },
});
